<template>
  <!-- Why Choose Us -->
  <section class="real-why-us">
    <div class="real-why-us-floating-bg">
      <img src="@/assets/img/bg/why-us-bg.png" alt="" />
    </div>
    <div class="container">
      <div class="section-heading section-heading-nine aos" data-aos="fade-up">
        <div class="row align-items-center">
          <div class="col-md-4"></div>
          <div
            class="col-md-4 aos aos-init aos-animate text-center"
            data-aos="fade-up"
          >
            <h2>Why Choose Us</h2>
            <p>We provide full service at every step.</p>
          </div>
          <div
            class="col-md-4 text-md-end aos aos-init aos-animate"
            data-aos="fade-up"
          ></div>
        </div>
      </div>
      <div class="row aos" data-aos="fade-up" data-aos-delay="200">
        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12">
          <div class="choose-set">
            <span><img src="@/assets/img/icons/why-us-1.svg" alt="img" /></span>
            <h6>Trusted By Thousands</h6>
            <p>
              With over 1 million+ homes for sale available on the website,
              Listee can match you with a house you will want to call home.
            </p>
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12">
          <div class="choose-set">
            <span><img src="@/assets/img/icons/why-us-2.svg" alt="img" /></span>
            <h6>Wide Range Of Properties</h6>
            <p>
              With over 1 million+ homes for sale available on the website,
              Listee can match you with a house you will want to call home.
            </p>
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12">
          <div class="choose-set">
            <span><img src="@/assets/img/icons/why-us-3.svg" alt="img" /></span>
            <h6>Financing Made Easy</h6>
            <p>
              With over 1 million+ homes for sale available on the website,
              Listee can match you with a house you will want to call home.
            </p>
          </div>
        </div>
        <div class="col-xl-3 col-lg-6 col-md-6 col-sm-12">
          <div class="choose-set">
            <span><img src="@/assets/img/icons/why-us-4.svg" alt="img" /></span>
            <h6>See Neighborhoods</h6>
            <p>
              With over 1 million+ homes for sale available on the website,
              Listee can match you with a house you will want to call home.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Why Choose Us -->

  <!-- Listed Properties Management Companies -->
  <section class="section properties-managments">
    <div class="container">
      <div class="section-heading section-heading-nine aos" data-aos="fade-up">
        <div class="row align-items-center">
          <div class="col-md-3"></div>
          <div
            class="col-md-6 aos aos-init aos-animate text-center"
            data-aos="fade-up"
          >
            <h2>Listed Properties Management Companies</h2>
            <p>The most trendy accommodations available</p>
          </div>
          <div
            class="col-md-3 text-md-end aos aos-init aos-animate"
            data-aos="fade-up"
          >
            <router-link to="categories" class="btn btn-view"
              >View all Companies</router-link
            >
          </div>
        </div>
      </div>
      <div class="row aos" data-aos="fade-up" data-aos-delay="200">
        <div class="col-lg-12">
          <div class="car-class-carousel">
            <div class="property-listing-slider owl-carousel owl-theme">
              <Carousel
                :wrap-around="true"
                :settings="settings"
                :breakpoints="breakpoints"
              >
                <Slide v-for="item in IndexNineCompanies" :key="item.id">
                  <div class="property-item">
                    <router-link to="categories"
                      ><div class="companies-set mb-4">
                        <div class="companies-set-head">
                          <div class="companies-set-logo">
                            <span
                              ><img
                                :src="
                                  require(`@/assets/img/icons/${item.image}`)
                                "
                                alt="img"
                            /></span>
                          </div>
                          <div class="companies-set-content">
                            <h5>
                              <span>{{ item.property_1 }}</span
                              >Properties
                            </h5>
                            <h6>{{ item.title_1 }}</h6>
                          </div>
                        </div>
                        <div class="companies-set-count">
                          <ul>
                            <li>
                              <h6>{{ item.list_1 }}</h6>
                              <span>Listing</span>
                            </li>
                            <li>
                              <h6>{{ item.list_2 }}</h6>
                              <span>Listing</span>
                            </li>
                            <li>
                              <h6>{{ item.list_3 }}</h6>
                              <span>Listing</span>
                            </li>
                          </ul>
                          <div class="companies-set-btn">
                            <router-link
                              to="listing-list-sidebar"
                              class="btn btn-linebtn"
                              >View All Listing<i
                                class="fa fa-arrow-right ms-3"
                                aria-hidden="true"
                              ></i
                            ></router-link>
                          </div>
                        </div></div
                    ></router-link>
                    <router-link to="categories"
                      ><div class="companies-set">
                        <div class="companies-set-head">
                          <div class="companies-set-logo">
                            <span
                              ><img
                                :src="
                                  require(`@/assets/img/icons/${item.avatar}`)
                                "
                                alt="img"
                            /></span>
                          </div>
                          <div class="companies-set-content">
                            <h5>
                              <span>{{ item.property_2 }}</span
                              >Properties
                            </h5>
                            <h6>{{ item.title_2 }}</h6>
                          </div>
                        </div>
                        <div class="companies-set-count">
                          <ul>
                            <li>
                              <h6>{{ item.category_1 }}</h6>
                              <span>Listing</span>
                            </li>
                            <li>
                              <h6>{{ item.category_2 }}</h6>
                              <span>Listing</span>
                            </li>
                            <li>
                              <h6>{{ item.category_3 }}</h6>
                              <span>Listing</span>
                            </li>
                          </ul>
                          <div class="companies-set-btn">
                            <router-link
                              to="listing-list-sidebar"
                              class="btn btn-linebtn"
                              >View All Listing<i
                                class="fa fa-arrow-right ms-3"
                                aria-hidden="true"
                              ></i
                            ></router-link>
                          </div>
                        </div></div
                    ></router-link>
                  </div>
                </Slide>
                <template #addons>
                  <Pagination />
                </template>
              </Carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /Listed Properties Management Companies -->
</template>
<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import IndexNineCompanies from "@/assets/json/indexNineCompanies.json";
export default {
  data() {
    return {
      IndexNineCompanies: IndexNineCompanies,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
      },

      breakpoints: {
        575: {
          itemsToShow: 2,
          snapAlign: "center",
        },
        // 700px and up
        700: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1000: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
  mouted() {},
};
</script>
